













































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import SerahTerimaKantongDarahDialog from "@/components/bank-darah/SerahTerimaKantongDarahDialog.vue";
import SerahTerimaKantongSvc from "@/services/SerahTerimaKantongDarah";
import { appModule } from "@/store/modules/app";
import { OpsiTeks, SerahTerimaKantongDarah } from "@/types/serah_terima_kantong_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({ components: { VCDateTimePicker, SerahTerimaKantongDarahDialog } })
export default class SerahTerimaKantongDarahPage extends Vue {
  filter: { tgl_start: string; tgl_end: string; term: string | null } = {
    tgl_start: moment().subtract(7, "days").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    term: null
  };

  rows: SerahTerimaKantongDarah[] = [];
  komponenOptions: OpsiTeks[] = [];
  maksBaris = 0;
  loading = false;
  dialog = false;
  editData: SerahTerimaKantongDarah | null = null;
  dialogHapus = false;
  hapusItem: SerahTerimaKantongDarah | null = null;
  deleting = false;

  readonly headers = [
    { text: "Tgl Crosstest", value: "tanggal_crosstest", width: "100px" },
    { text: "No Registrasi Sampel", value: "no_registrasi_sampel", sortable: false },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Bangsal", value: "bangsal" },
    { text: "Komponen / Golda", value: "darah", sortable: false },
    { text: "No Kantong", value: "nomor_kantong", sortable: false },
    { text: "Diambil", value: "diambil_at", width: "120px" },
    { text: "Petugas", value: "petugas", sortable: false },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "80px" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.muat();
  }

  tanggal(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD").format("DD-MM-YYYY") : "-";
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  async muat() {
    this.loading = true;
    try {
      const res = await SerahTerimaKantongSvc.list(this.filter);
      this.rows = res.rows;
      this.komponenOptions = res.komponen_options;
      this.maksBaris = res.maks_baris;
    } catch {
      this.rows = [];
    } finally {
      this.loading = false;
    }
  }

  buka(item: SerahTerimaKantongDarah | null) {
    this.editData = item;
    this.dialog = true;
  }

  konfirmHapus(item: SerahTerimaKantongDarah) {
    this.hapusItem = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.hapusItem || !this.hapusItem.id || this.deleting) return;
    this.deleting = true;
    try {
      const res = await SerahTerimaKantongSvc.destroy(this.hapusItem.id);
      appModule.sendSuccessNotice(res.message);
      this.dialogHapus = false;
      this.hapusItem = null;
      this.muat();
    } catch {
      return;
    } finally {
      this.deleting = false;
    }
  }
}
